// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tables_content__X0wbk {
  margin-top: 70px;
}

.tables_tables__9dn2T {
  position: relative;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(284px, 1fr));
}

.tables_header_button__WD\\+S\\+ {
  display: none;
}

.tables_tables_block__3SeyG {
  border: 2px solid #7EDB88;
  border-radius: 12px;
  background: linear-gradient(to bottom, #7EDB88 0%, #3FA449 55%, #299334 70%, #2E9939 90%, #2E9939 100%);
  padding: 20px;
  display: flex;
  height: 100%;
  max-width: 350px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tables_tables_block_image__Wxetc {
  max-width: 264px;
  max-height: 199px;
  border-radius: 6px;
}
.tables_tables_block_image__Wxetc img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.tables_tables_block_text__Bf0cw {
  text-decoration: none;
  font-size: 20px;
  line-height: 24px;
  color: white;
  font-family: var(--font-rubik);
  margin-top: 16px;
  padding: 0 14px;
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
}

@media screen and (max-width: 1440px) {
  .tables_header_button__WD\\+S\\+ {
    display: block;
  }
  .tables_header__l-hXM {
    display: flex;
    flex-direction: column-reverse;
    grid-template-columns: 1fr;
  }
  .tables_header_block__HAqM- {
    display: flex;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 16px 20px;
  }
  .tables_header_block__HAqM- img {
    width: auto;
  }
  .tables_flexcenter__Qaw9p {
    justify-content: center;
  }
  .tables_header_side__TwBVu {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .tables_flexcenter__Qaw9p div {
    max-width: 247px;
  }
  .tables_header_block__HAqM- img:nth-child(2) {
    width: 215px;
    height: 62px;
  }
}
@media screen and (max-width: 600px) {
  .tables_tables__9dn2T {
    grid-template-columns: 1fr;
  }
  .tables_flexcenter__Qaw9p {
    align-items: center;
    flex-direction: column;
  }
  .tables_flexcenter__Qaw9p div:nth-child(1) {
    margin-bottom: 10px;
  }
  .tables_header_block__HAqM- {
    padding: 8px 15px;
  }
  .tables_header_block__HAqM- img:nth-child(2) {
    width: 134px;
    height: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tables/tables.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,4DAAA;AACF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,yBAAA;EACA,mBAAA;EACA,uGAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAIE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AADN;AAIE;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAMA;EAEE;IACE,cAAA;EAJF;EAOA;IACE,aAAA;IACA,8BAAA;IACA,0BAAA;EALF;EAQA;IACE,aAAA;IACA,yCAAA;IACA,8BAAA;IACA,kBAAA;EANF;EAOE;IACE,WAAA;EALJ;EASA;IACE,uBAAA;EAPF;EAUA;IACE,aAAA;EARF;AACF;AAaA;EAEI;IACE,gBAAA;EAZJ;EAiBE;IACE,YAAA;IACA,YAAA;EAfJ;AACF;AAmBA;EAEE;IACE,0BAAA;EAlBF;EAqBA;IACE,mBAAA;IACA,sBAAA;EAnBF;EAoBE;IACE,mBAAA;EAlBJ;EAsBA;IACE,iBAAA;EApBF;EAqBE;IACE,YAAA;IACA,YAAA;EAnBJ;AACF","sourcesContent":[".content {\n  margin-top: 70px;\n}\n\n.tables {\n  position: relative;\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fill, minmax(calc(304px - 20px), 1fr));\n}\n\n.header {\n\n}\n\n.header_button {\n  display: none;\n}\n\n.tables_block {\n  border: 2px solid #7EDB88;\n  border-radius: 12px;\n  background: linear-gradient(to bottom, #7EDB88 0%, #3FA449 55%, #299334 70%, #2E9939 90%, #2E9939 100%);\n  padding: 20px;\n  display: flex;\n  height: 100%;\n  max-width: 350px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  &_image {\n    max-width: 264px;\n    max-height: 199px;\n    border-radius: 6px;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      border-radius: 6px;\n    }\n  }\n  &_text {\n    text-decoration: none;\n    font-size: 20px;\n    line-height: 24px;\n    color: white;\n    font-family: var(--font-rubik);\n    margin-top: 16px;\n    padding: 0 14px;\n    text-transform: uppercase;\n    font-weight: 500;\n    text-align: center;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n\n  .header_button {\n    display: block;\n  }\n\n  .header {\n    display: flex;\n    flex-direction: column-reverse;\n    grid-template-columns: 1fr;\n  }\n\n  .header_block {\n    display: flex;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 16px 20px;\n    img {\n      width: auto;\n    }\n  }\n\n  .flexcenter {\n    justify-content: center;\n  }\n\n  .header_side {\n    display: none;\n  }\n}\n\n\n\n@media screen and (max-width: 768px) {\n  .flexcenter {\n    div {\n      max-width: 247px;\n    }\n  }\n\n  .header_block {\n    img:nth-child(2) {\n      width: 215px;\n      height: 62px;\n    }\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .tables {\n    grid-template-columns: 1fr;\n  }\n\n  .flexcenter {\n    align-items: center;\n    flex-direction: column;\n    div:nth-child(1) {\n      margin-bottom: 10px;\n    }\n  }\n\n  .header_block {\n    padding: 8px 15px;\n    img:nth-child(2) {\n      width: 134px;\n      height: 38px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tables_content__X0wbk`,
	"tables": `tables_tables__9dn2T`,
	"header_button": `tables_header_button__WD+S+`,
	"tables_block": `tables_tables_block__3SeyG`,
	"tables_block_image": `tables_tables_block_image__Wxetc`,
	"tables_block_text": `tables_tables_block_text__Bf0cw`,
	"header": `tables_header__l-hXM`,
	"header_block": `tables_header_block__HAqM-`,
	"flexcenter": `tables_flexcenter__Qaw9p`,
	"header_side": `tables_header_side__TwBVu`
};
export default ___CSS_LOADER_EXPORT___;
